<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-col style="display: flex;
  flex-flow: column;
  height: 100%; padding: 0">
        <b-row style=" flex-grow : 1; margin: 0px">
        </b-row>
        <md-dialog-alert :md-close-on-esc="false" :md-click-outside-to-close="false"
                         :md-active.sync="showFinish"
                         :md-title="dialogTitle"
                         :md-content="dialogMessage"
                         md-confirm-text="Ok"
                         @md-closed="goback"/>
    </b-col>
</template>

<script>

    import {Server_URL_MAENGELMELDER} from "../shared/utils";

    export default {
        name: "Unsubscribe",
        mounted() {
            this.commune = this.$route.params.id;
            this.defect  = this.$route.query.defect;

            this.showLoader();
            this.$http.get(
                Server_URL_MAENGELMELDER + '/mm/unsubscribe/'+this.$route.params.id + "?defect=" + this.defect
            ).then(this.responseOkFinish, this.responseError)

        },
        data() {
            return {
                commune: "",
                defect: "",
                showFinish: false,
                error: false,
            }
        },
        computed: {
            dialogTitle () {
                if (this.error) {
                    return "Fehler"
                } else {
                    return "Meldungen abbestellt"
                }
            },
            dialogMessage () {
                if (this.error) {
                    return "Die gewünschte Aktion konnte nicht ausgeführt werden."
                } else {
                    return "Sie werden nun keine weiteren Meldungen bezüglich dieser Mängelmeldung bekommen."
                }
            },
        },
        methods: {
            showLoader() {
                this.loader = this.$loading.show();
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseError(response) {
                this.hideLoader();
                this.error = true;
                this.showFinish = true;
                if (response.status === 401) {
                    console.log(response);
                } else {
                    console.log(response);
                }
            },
            responseOkFinish(response) {
                this.hideLoader();
                if (response.status === 200) {
                    this.showFinish = true;
                } else {
                    console.log(response);
                }
            },
            goback() {
                window.close();
            }
        },
    }
</script>

<style scoped>
    @import '../../node_modules/vue-material/dist/vue-material.min.css';
    @import '../../node_modules/vue-material/dist/theme/default.css';

    .hoverable-icon:hover {
        cursor: pointer;
    }

</style>
